export type SearchParams = Record<string, string | string[] | number | boolean>;

export class UrlUtils {
    static generateAlgoRobotPackageDetailPageUrl(packageId: string): string {
        return `/algo-robots/${packageId}`;
    }

    static generateAbsoluteUrl(path: string, params?: Record<string, any>): string {
        const dest = new URL(path, location.origin);
        if (params) {
            Object.keys(params).forEach((key) => {
                const param = params[key];
                const strParam = Array.isArray(param) ? param.join(',') : `${param}`;
                dest.searchParams.append(key, strParam);
            });
        }
        return dest.toString();
    }
}